<template>
    <div class="prod-list">
        <img src="../img/prod/6.jpg" />
        <div v-for="(item, index) in arr" :key="index">
            <div class="prod-item">
                <img :src="item.img"
                    @click="clickItem(item)"
                    :usemap="item.usemap || ''" />
                    <div class="area" v-for="i in item.area || []" :style="i.coords" @click="clickItem(i)" :key="i.id"/>
            </div>
        </div>
    </div>
</template>
<script>
import {BRAND} from '../constant/brand'
const blueArr = [
  {
    id: 112841,
    img: require('../img/prod/blue-1.jpg'),
    brand: BRAND.BLUE
  },
  {
    id: 112841,
    img: require('../img/prod/blue-2.jpg'),
    brand: BRAND.BLUE
  },
  {
    id: 112841,
    img: require('../img/prod/blue-3.jpg'),
    brand: BRAND.BLUE
  }
]
const masterArr = [
  {
    id: 113518,
    img: require('../img/prod/master-1.png'),
    brand: BRAND.MASTER
  },
  {
    id: 113518,
    img: require('../img/prod/master-2.png'),
    brand: BRAND.MASTER
  },
  {
    id: 113518,
    img: require('../img/prod/master-3.png'),
    brand: BRAND.MASTER
  },
  {
    id: 0,
    img: require('../img/prod/master-4.png'),
    brand: BRAND.MASTER,
    area: [
      {
        coords: 'right:6%;top:0%;width:45%;height:20%',
        id: 113518,
        brand: BRAND.MASTER
      },
      {
        coords: 'left:15%;top:17%;width:48%;height:32%',
        id: 109785,
        brand: BRAND.MASTER
      },
      {
        coords: 'left:22%;top:58%;width:57%;height:38%',
        id: 93193,
        brand: BRAND.MASTER
      }
    ]
  }
]
const labArr = [
  {
    id: 114207,
    img: require('../img/prod/lab-1.jpg'),
    brand: BRAND.MASTER
  },
  {
    id: 0,
    img: require('../img/prod/lab-2.jpg'),
    brand: BRAND.BLUE,
    area: [
      {
        coords: 'left:10%;top:3%;width:78%;height:32%',
        id: 111087,
        brand: BRAND.BLUE
      },
      {
        coords: 'left:20%;top:42%;width:60%;height:56%',
        id: 114200,
        brand: BRAND.BLUE
      }
    ]
  },
  {
    id: 109362,
    img: require('../img/prod/lab-3.jpg'),
    brand: BRAND.BLUE
  }
]
const mantoArr = [
  {
    id: 107404,
    img: require('../img/prod/manto-1.jpg'),
    brand: BRAND.MANTO
  },
  {
    id: 106802,
    img: require('../img/prod/manto-2.jpg'),
    brand: BRAND.MANTO
  }
]
const arr = [
  ...blueArr,
  ...masterArr,
  ...labArr,
  ...mantoArr

]
export default {
  data () {
    return {
      arr
    }
  },
  methods: {
    clickItem (item) {
      if (item.id) this.$emit('change',item.brand,item.id)
    }
  }
}
</script>
<style lang="less" scoped>
.prod-list {
  img {
    display: flex; // 兼容图片白边
    width: 375px;
    height: auto;
  }
}

.prod-item {
  img {
    display: flex; // 兼容图片白边
    width: 375px;
    height: auto;
  }

  position: relative;
  margin-top: -1px; // 兼容图片白边
}

.area {
  position: absolute;
  // background: #000; // 热力区
}

</style>
